import type { Lecture, LectureDetail } from '@/types/lecture.types'

const LEVEL_MAP = {
  'BEGINNER': '초급',
  'INTERMEDIATE': '중급',
  'ADVANCED': '고급',
  'ALL': '전체'
} as const

export type LectureLevel = keyof typeof LEVEL_MAP

export function getKoreanLevel(level: string): string {
  return LEVEL_MAP[level as LectureLevel] || level
}

export function getKoreanLevelFromLecture(lecture: Lecture | LectureDetail): string {
  return getKoreanLevel(lecture.level)
}
